const ASSET_BASE_URL = import.meta.env.VITE_ASSET_URL;

/**
 * 生成 lenormand 图片的完整 URL
 * @param path - 图片在 lenormand/image/ 目录下的路径
 * @returns 完整的图片 URL
 */
export function getImageUrl(path: string, prefix: string = 'image'): string {
  return `${ASSET_BASE_URL}/${prefix}/${path}`;
}
